<div *ngIf="loader" class="loader">
    <mat-spinner></mat-spinner>
  </div>

<div mat-dialog-title class="d-flex flex-column position-relative" *ngIf="!loader && data.requestTypeInfo.requestType == 'User Profile'">
    <button
      mat-icon-button
      mat-dialog-close
      class="align-self-end"
      color="accent"
    >
      <mat-icon>close</mat-icon>
    </button>
    <div class="profile-title d-flex flex-column align-items-center">
      <img
        [src]="
          metadata['imageThumbUrl'] !== null && metadata['imageThumbUrl'] !== 'null'
            ? metadata['imageThumbUrl']
            : './assets/images/user-avatar.svg'
        "
        class="img-fluid rounded-circle mx-auto mb-4"
      />
      <h2 class="mb-0">{{ metadata.entityName | titlecase }}</h2>
    </div>
  </div>
  <mat-dialog-content *ngIf="!loader">
    <mat-list>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">info</mat-icon>
        <div mat-line>
          Address: <span>{{ metadata.addressInfo.address_line }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >account_circle</mat-icon
        >
        <div mat-line>
          Owner name: <span>{{ metadata.ownerName }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
          Description: <span>{{ metadata.entityDesc}}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <!-- <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">phone</mat-icon>
        <div mat-line>
          Phone number: <span>{{ data.phone }}</span>
        </div>
      </mat-list-item> -->
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >admin_panel_settings</mat-icon
        >
        <div mat-line>
          Phone: <span>{{ metadata.entityPhone }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
          Report category: <span>{{ data.categoryType}}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">phone</mat-icon>
        <div mat-line>
          Report message: <span>{{ data.message }}</span>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-dialog-content>